import { useEffect, useState } from "react";
import XDataGrid from "../components/XDataGrid";
import instance, { setAuthToken } from "../services/api";

export default function ServicePersons() {
  const [servicePerson, setServicePerson] = useState([]);

  useEffect(() => {
    setAuthToken(localStorage.getItem("token"));
    instance
      .get("/executive/list/")
      .then((response) => {
        setServicePerson(
          response.data.results.map((executive) => {
            executive.id = executive.uuid;
            return executive;
          })
        );
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  return <XDataGrid data={servicePerson} />;
}
